export default [
  {
    title: 'Settings',
    icon: 'SettingsIcon',
    route: 'page-layout-layout-empty',    
    children: [
      {
        title: 'Hardware Setup (Stock)',
        route: 'setting-hardware-type', 
        icon: 'PrinterIcon',
        permissionCode:'ST001',
      },
      {
        title: 'Hardware Setup (Warranty)',
        route: 'setting-hardware-warranty-type', 
        icon: 'PrinterIcon',
        permissionCode:'ST002',
      },
      {
        title: 'Customer Setup (Stock)',
        route: 'setting-customer-owner', 
        icon: 'UsersIcon',
        permissionCode:'ST003',
      },
      {
        title: 'Customer Setup (Warranty)',
        route: 'setting-customer-warranty-subcompany', 
        icon: 'UsersIcon',
        permissionCode:'ST003-1',
      },
      {
        title: 'Roles and Permission',
        route: 'setting-role', 
        icon: 'BoxIcon',
        permissionCode:'ST004',
      },
      {
        title: 'Manage Users',
        route: 'setting-user', 
        icon: 'UserIcon',
        permissionCode:'ST005',
      },
      {
        title: 'ตั้งค่าระยะทางลูกค้า',
        route: 'setting-distance-customer', 
        icon: 'MapPinIcon',
        permissionCode:'ST006',
      },
      {
        title: 'ตั้งค่าระยะทางพนักงาน',
        route: 'setting-distance-employee', 
        icon: 'MapIcon',
        permissionCode:'ST007',
      },
      {
        title: 'ตั้งค่า Email',
        route: 'setting-email', 
        icon: 'MailIcon',
        permissionCode:'ST008',
      }
    ]            
  },
]


